import axios from "axios";
export const reportService = {
  getExecutedReports,
  getConfiguredReports,
  loadPipelinesByPipelineId
};

var qs = require("qs");
function getExecutedReports(params) {
  return axios
    .get("Reporting/reports", {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      }
    })
    .then(handleResponse)
    .catch(error => {
      return Promise.reject(error);
    });
}

function loadPipelinesByPipelineId(params) {
  return axios
    .get("Reporting/pipelines", { params: params })
    .then(handleResponse)
    .catch(error => {
      return Promise.reject(error);
    });
}

/* active: true
createdByUser: "pudzata1"
customer: "123123"
customerId: "qew31"
triggerCriteria: {}
triggerType: "fibfilearrived"
_id: "6087f9687d46f83ca5e4a4f2" */

function getConfiguredReports(params) {
  return axios
    .get("Reporting/Definitionslist", {
      params: { ...params, IncludeSchedules: true },
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      }
    })
    .then(handleResponse)
    .catch(error => {
      return Promise.reject(error);
    });
}

function handleResponse(response) {
  if (response.data.Errors && response.data.Errors.length > 0) {
    // TODO handle error
    return Promise.reject(response.data.Errors[0]);
  }
  return Promise.resolve(response.data);
}
